import React from 'react'
import SVG from 'react-svg-inline'

const Stylemarks = () =>
  <div>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          Stylemarks was my first job at a real startup – wow. It was marketplace for second hand vintage & design related items that quickly turned into a curated marketplace like fab, fancy or etsy. It was… "fun" :)
        </blockquote>
      </div>
    </section>
    <section className="container">
      <div className="col-12-of-12">
        <img src={require('img/stylemarks/laptop-0.jpg')} alt="Stylemarks Heatmap" />
      </div>
    </section>
    <section className="container-full">
      <div className="col-12-of-12">
        <img src={require('img/stylemarks/stylemarks-image-2.png')} alt="Stylemarks Heatmap" />
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          Most of the projects done at that time could be categorised as web, app or graphic production. I remember that at that time the biggest challenge on the iOS app was to transition from iOS-6 to iOS-7
        </blockquote>
      </div>
    </section>
    <section className="container">
      <div className="col-12-of-12">
        <img src={require('img/stylemarks/laptop-3.jpg')} alt="Stylemarks" />
      </div>
    </section>
    <section className="container">
      <div className="col-12-of-12">
        <img src={require('img/stylemarks/laptop-4.jpg')} alt="Stylemarks" />
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          It was quite insightful to start working based on metrics and real life users, and during that year we managed to gain a good rythm of releases & iterations due to some pretty solid processes.
        </blockquote>
      </div>
    </section>
    <section className="container">
      <div className="col-12-of-12">
        <img src={require('img/stylemarks/laptop-1.jpg')} alt="Stylemarks" />
      </div>
    </section>
    <section className="container">
      <div className="col-12-of-12">
        <img src={require('img/stylemarks/laptop-2.jpg')} alt="Stylemarks" />
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          In retrospective I'm suprised of such a young team performing with way more synergy than other "more experienced" companies… I guess sometimes it all comes down to attitude and willingess to empatise.
        </blockquote>
      </div>
    </section>
  </div>

export default Stylemarks



// WEBPACK FOOTER //
// src/javascripts/clients/Stylemarks.js